import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Card, CardMedia, Container, makeStyles } from '@material-ui/core';
import ReactPlayer from 'react-player';
import usePage from '@/hooks/usePage.js';
import Request from '@/helpers/request.js';
import Constants from '@/constants.js';
import mainStyles from '@/assets/js/mainStyles.js';

const useStyles = makeStyles(mainStyles);

const InnovationImplementation = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [accessor, setComponent] = useState({});
  const { setTitle } = usePage();

  useEffect(async () => {
    const fetch = async () => {
      const response = await Request.get(`/p3d2-accessories/${id}`);
      setComponent(response);
    };
    setTitle('Mise en œuvre');
    await fetch();
  }, []);
  const accessorData = accessor.usage
    ? accessor.usage
    : {
        text: '',
        video: '',
        image: null,
      };

  return (
    <Container maxWidth="md">
      <Box className={classes.descRoot}>
        <div className={classes.secTitle}>
          <span>{accessor?.title} </span>
        </div>
        <div className={classes.description}>{accessorData.text}</div>
        {accessorData.image && (
          <Card className={classes.imgCard}>
            <CardMedia
              className={classes.imgItem}
              accessor="img"
              image={`${Constants.BASE_URL}/${accessorData.image.path} `}
            />
          </Card>
        )}
        {accessorData?.video && (
          <Box justifyContent={'center'} className={classes.videoBox}>
            <ReactPlayer url={accessorData?.video} width="100%" height="100%" controls />
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default InnovationImplementation;
